import { render } from "./PosteVerte.vue?vue&type=template&id=91b70e36&ts=true"
import script from "./PosteVerte.vue?vue&type=script&lang=ts"
export * from "./PosteVerte.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__